import DefaultContainer from '@/layout/containers/default-container/default-container';

export default DefaultContainer;
